import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { LanguageSelector } from "@/components/LanguageSelector";
import { LanguageCard } from "@/components/LanguageCard";
import { appUrls } from "@/utilities/appUrls";
import sendolaLogo from "@/assets/Img/logo-sendola-2026.png";

/* Both CTAs stay visible at every breakpoint — they shrink instead of
   collapsing behind a menu. `min-h-[44px]` keeps the mobile touch target
   at the accessible minimum while the font/padding scale down. */
const ctaBaseClass =
  "inline-flex items-center justify-center whitespace-nowrap font-semibold font-montserrat rounded-xl min-h-[44px] text-[11px] xs:text-xs sm:text-sm lg:text-base xl:text-lg px-2.5 xs:px-4 sm:px-6 lg:px-10 xl:px-16 py-2 lg:py-3 xl:py-4";

export const HomeownersHeader = () => {
  const [t] = useTranslation("homeowners");
  const [showLanguageBar, setShowLanguageBar] = useState(false);
  const [verticalScrolled, setVerticalScrolled] = useState(false);

  useEffect(() => {
    const checkVerticalScroll = () => {
      setVerticalScrolled(window.scrollY > 60);
    };

    window.addEventListener("scroll", checkVerticalScroll);
    return () => window.removeEventListener("scroll", checkVerticalScroll);
  }, []);

  return (
    <>
      <nav className="z-50 fixed top-0 left-0 w-full transition-all duration-200 ease-in">
        <div
          className={classNames(
            "w-full flex justify-between items-center gap-2 transition-all px-3 xs:px-5 sm:px-6 lg:px-12 xl:px-24 py-3 sm:py-4 lg:py-5",
            {
              "bg-homeowners-bg/95 backdrop-blur-sm shadow-sm":
                verticalScrolled,
              "bg-transparent": !verticalScrolled,
            }
          )}
        >
          {/* Logo */}
          <a href="/" className="flex-shrink-0">
            <img
              className="h-7 xs:h-9 sm:h-11 lg:h-14 w-auto object-contain select-none"
              src={sendolaLogo}
              alt="Sendola Pay Logo"
            />
          </a>

          {/* Actions — always visible, never wrap */}
          <div className="flex flex-nowrap items-center flex-shrink-0 gap-2 xs:gap-3 sm:gap-4 lg:gap-8 xl:gap-14">
            <a
              href={appUrls.signUp}
              className={classNames(
                ctaBaseClass,
                "bg-homeowners-purple text-white hover:opacity-90 transition-opacity"
              )}
            >
              {t("Nav.SignUp")}
            </a>
            <a
              href={appUrls.login}
              className={classNames(
                ctaBaseClass,
                "border-2 border-homeowners-purple text-homeowners-purple hover:bg-homeowners-purple/10 transition-colors"
              )}
            >
              {t("Nav.LogIn")}
            </a>
            <LanguageSelector
              blackText
              onClick={() => setShowLanguageBar(!showLanguageBar)}
            />
          </div>
        </div>
      </nav>

      <LanguageCard
        show={showLanguageBar}
        onClose={() => setShowLanguageBar(false)}
      />
    </>
  );
};
